import * as React from 'react';
import styled from 'threads5/styles/styled';
import { ITheme as PlaidTheme } from 'threads5/themes/theme';
import SxProps from 'threads5/themes/sx-props';

// Styled as the design-system Eyebrow, which is Cern per the foundations (SITE-6098)
const StyledHeading = styled('h1')(({ theme }) => {
  return {
    fontFamily: theme.typography.cern,
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '100%',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.4rem',
      lineHeight: '112%',
      letterSpacing: '1.25px',
    },
  };
});

const Heading1 = React.forwardRef<
  HTMLHeadingElement,
  React.ComponentPropsWithRef<'h1'> & { sx?: SxProps<PlaidTheme> }
>(({ sx, ...props }, ref) => {
  return (
    <StyledHeading ref={ref} sx={sx} {...props}>
      Pricing Plans
    </StyledHeading>
  );
});
Heading1.displayName = 'Heading1';

export default Heading1;
